(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ci-entete"]) return;
  try {
    
  // Publie la hauteur de l'en-tête (--ci-entete-h) pour que le hero se place dessous, referme le
  // menu mobile avec Échap, ouvre les sous-menus au clic, et cache l'en-tête quand on descend
  // dans la page pour le faire revenir dès qu'on remonte.
  class CiEntete extends HTMLElement {
    connectedCallback() {
      this.ro = new ResizeObserver(() => {
        document.documentElement.style.setProperty('--ci-entete-h', this.offsetHeight + 'px');
      });
      this.ro.observe(this);
      this.mobile = this.querySelector('.ci-entete__mobile');
      this.onKey = (e) => {
        if (e.key === 'Escape' && this.fermerSousMenus) this.fermerSousMenus(null);
        if (e.key === 'Escape' && this.mobile && this.mobile.open) {
          this.mobile.open = false;
          this.mobile.querySelector('summary').focus();
        }
      };
      document.addEventListener('keydown', this.onKey);

      // Sous-menus : ouverture au clic (écrans tactiles), en plus du survol et du clavier
      this.parents = Array.from(this.querySelectorAll('.ci-entete__parent'));
      const fermer = (sauf) =>
        this.parents.forEach((p) => {
          if (p === sauf) return;
          p.classList.remove('is-ouvert');
          p.querySelector('button').setAttribute('aria-expanded', 'false');
        });
      this.parents.forEach((parent) => {
        const bouton = parent.querySelector('button');
        bouton.addEventListener('click', () => {
          const ouvert = parent.classList.toggle('is-ouvert');
          bouton.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
          fermer(parent);
          if (!ouvert) bouton.blur();
        });
      });
      this.onClic = (e) => {
        if (!e.target.closest || !e.target.closest('.ci-entete__parent')) fermer(null);
      };
      document.addEventListener('click', this.onClic);
      this.fermerSousMenus = fermer;

      // En-tête collant : caché à la descente, de retour à la remontée
      this.groupe = this.closest('#header-group') || this.parentElement;
      this.dernier = 0;
      this.onDefile = (e) => {
        const cible = e.target === document ? document.scrollingElement : e.target;
        if (!cible || (cible !== document.scrollingElement && !cible.classList.contains('page-wrapper'))) return;
        const y = cible.scrollTop;
        const ecart = y - this.dernier;
        this.groupe.classList.toggle('ci-detache', y > 8);
        if (y <= this.offsetHeight) {
          this.groupe.classList.remove('ci-cache');
        } else if (Math.abs(ecart) > 6) {
          const menuOuvert = (this.mobile && this.mobile.open) || this.querySelector('.ci-entete__parent.is-ouvert');
          this.groupe.classList.toggle('ci-cache', ecart > 0 && !menuOuvert);
          if (ecart > 0) fermer(null);
        }
        if (Math.abs(ecart) > 6 || y <= 8) this.dernier = y;
      };
      window.addEventListener('scroll', this.onDefile, { passive: true, capture: true });
      // État de départ : une page rechargée au milieu doit avoir tout de suite un en-tête opaque
      this.depart = () => {
        const enveloppe = document.querySelector('.page-wrapper');
        const defile = enveloppe && getComputedStyle(enveloppe).overflowY !== 'visible' && enveloppe.scrollHeight > enveloppe.clientHeight;
        this.onDefile({ target: defile ? enveloppe : document });
      };
      this.depart();
      window.addEventListener('pageshow', this.depart);
    }
    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
      document.removeEventListener('keydown', this.onKey);
      document.removeEventListener('click', this.onClic);
      window.removeEventListener('scroll', this.onDefile, { capture: true });
      window.removeEventListener('pageshow', this.depart);
    }
  }
  if (!customElements.get('ci-entete')) customElements.define('ci-entete', CiEntete);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
